//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      selectArr: [],
      allKeyWord: {
        province: [
          "桂",
          "京",
          "湘",
          "津",
          "鄂",
          "沪",
          "粤",
          "渝",
          "琼",
          "翼",
          "川",
          "晋",
          "贵",
          "辽",
          "云",
          "吉",
          "陕",
          "黑",
          "甘",
          "苏",
          "青",
          "浙",
          "皖",
          "藏",
          "闽",
          "蒙",
          "赣",

          "鲁",
          "宁",
          "豫",
          "新",
        ],
        alphabet: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          0,
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
          "-",
        ],
      },
      show: false,
      showFirst: false,
    };
  },
  watch: {
    selectArr(val) {
      this.$emit("input", val.join(""));
    },
  },
  methods: {
    showWrap() {
      this.show = true;
      this.showFirst = !(this.selectArr.length > 0);
    },
    selectFirstWord(item) {
      this.addSelect(item);
      this.showFirst = false;
    },
    clickKeyBoard(item) {
      this.addSelect(item);
    },
    addSelect(item) {
      // 点击自定义键盘
      let check_len = 7;
      if (this.selectArr.join().indexOf("-")) check_len = 9;

      if (this.selectArr[2] == "D" || this.selectArr[2] == "F") check_len = 8;

      if (this.selectArr.length < check_len) {
        this.selectArr.push(item);
      } else {
        this.close();
      }
    },
    deleteItem() {
      this.selectArr.pop();
      this.showFirst = !(this.selectArr.length > 0);
    },
    close() {
      this.show = false;
    },
    clickMask() {
      // console.log('clickMask')
      this.close();
    },
  },
  mounted() {
    let that = this;
    that.$bus.on("closePlateSelector", () => {
      that.close();
    });

    that.$bus.on("showPlateSelector", () => {
      that.showWrap();
    });

    this.selectArr = [];
    let container = document.querySelector(".container");
    container.addEventListener("click", (event) => {
      if (
        event.target.id !== "carInput" &&
        event.target.nodeName !== "SPAN" &&
        event.target.nodeName !== "DIV" &&
        event.target.nodeName !== "I"
      ) {
        this.close();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/carInput.vue